module.exports = __webpack_public_path__ + "static/img/ocean-poster-mobile.8334c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ocean-poster-mobile.jpg
// module id = +mYa
// module chunks = 1